import { Component } from '@angular/core';

@Component({
    templateUrl: './my-degree-help.component.html',
    styleUrls: ['./my-degree-help.component.scss'],
    selector: 'my-degree-help',
    standalone: false
})
export class MyDegreeHelpComponent{}

